import React from "react";
import { useFormContext } from "../../context/FormContext";
import styles from "./SuccessScreen.module.css";
import { Link, useNavigate, useLocation } from "react-router-dom";

const SurveySuccessScreen = () => {
  let context = {};
  try {
    context = useFormContext();
  } catch (e) {
    // Context might not be available
  }

  const navigate = useNavigate();
  const location = useLocation();
  const { type } = location.state || {};

  const isDraft = type === "draft";

  const goBack = () => {
    navigate(-1);
  };

  const handleClose = () => {
    if (window.parent && window.parent !== window) {
      window.parent.postMessage("close-survey", "*");
    } else {
      navigate(-1);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.innerContainer}>
        <img
          src="https://res.cloudinary.com/crown-interactive/image/upload/v1652192061/success_yhtjst.svg"
          alt=""
        />
        <p className={styles.success}>{isDraft ? "Draft Saved" : "Success"}</p>
        <p>
          {isDraft 
            ? "You can close this window or keep editing." 
            : "Your response has been submitted successfully. Close the window to continue."}
        </p>
        
        {isDraft ? (
           <button onClick={goBack} className={styles.submit} style={{ border: 'none', background: 'none', cursor: 'pointer' }}>
           <svg
             xmlns="http://www.w3.org/2000/svg"
             width="14"
             height="14"
             fill="#0082d3"
             viewBox="0 0 512 512"
             style={{ marginRight: '8px' }}
           >
             <path d="M496 48V192c0 17.69-14.31 32-32 32H320c-17.69 0-32-14.31-32-32s14.31-32 32-32h63.39c-29.97-39.7-77.25-63.78-127.6-63.78C167.7 96.22 96 167.9 96 256s71.69 159.8 159.8 159.8c34.88 0 68.03-11.03 95.88-31.94c14.22-10.53 34.22-7.75 44.81 6.375c10.59 14.16 7.75 34.22-6.375 44.81c-39.03 29.28-85.36 44.86-134.2 44.86C132.5 479.9 32 379.4 32 256s100.5-223.9 223.9-223.9c69.15 0 134 32.47 176.1 86.12V48c0-17.69 14.31-32 32-32S496 30.31 496 48z" />
           </svg>
           Keep editing
         </button>
        ) : (
          <div style={{ padding: '1rem 0' }}></div>
        )}

        {/* Close button */}
        <div className={styles.closeButton}>
            <button onClick={handleClose}>Close Window</button>
        </div>

        <div className={styles.footer}>
          <p>
            Powered by <a href="#!"> Galaxy Backbone 1Gov Cloud</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SurveySuccessScreen;
